import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import { CustomStyledBox } from '../../../../shared/IconLargeCicle/style';
import Grid from '@mui/material/Grid';
import { FeedbackUserData } from '../styled';
import { IAttendanceDeclarationResponse } from '../../../../../services/schedule.service';
import { formatOnlyDate, formatOnlyHour } from '../../../../../lib/dayjs';

export default function Success({ data }: { data: IAttendanceDeclarationResponse }) {
  return (
    <>
      <Grid>
        <CustomStyledBox sx={{ backgroundColor: 'brand.lightGreen' }}>
          <CheckIcon />
        </CustomStyledBox>
      </Grid>
      <Grid>
        <Typography variant="h2" sx={{ mb: 1 }}>
          Código validado
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Segue os dados para confirmação da Declaração de Comparecimento apresentada:
        </Typography>
      </Grid>
      <Grid>
        <FeedbackUserData>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Paciente: {data.patient.fullName}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            CPF: {data.patient.cpf}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Data do agendamento: {formatOnlyDate(data.schedule.dateStart)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Horário: {formatOnlyHour(data.schedule.dateStart, data.schedule.dateEnd)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Local: {data.calendar.location || 'atendimento previamente agendado junto à Oya Care.'}
          </Typography>
        </FeedbackUserData>
      </Grid>
    </>
  );
}
